import type { ModelSchema } from '@ember-data/store/types';
import type { OtaId } from 'frontend-utils/utils/constants/constant-values';
import ApplicationSerializer from 'lumen/serializers/application';

interface ScreenshotParityPayload {
  channel: OtaId;
  hotelinfo_id: number;
  id: string;
  max_persons: number;
  membershiptype: number;
  ota: string;
  period: string;
  platform: number;
  pos: string;
  screenshot: string; // Added by serializer
}

export default class ScreenshotParitySerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(): string {
    return 'parity/screenshot-parity';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(typeClass: ModelSchema, hash: ScreenshotParityPayload) {
    hash.id = [
      hash.period,
      hash.hotelinfo_id,
      hash.ota,
      hash.platform,
      hash.pos,
      hash.membershiptype,
      hash.max_persons,
      hash.channel,
    ].join(',');

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }
}
